import { z } from 'zod';
// BlockContent is simplified to `any` for validations
const BlockContentSchema = z.object({
    blocks: z.array(z.any())
});
export const I18nBlockContentSchema = z.object({
    'en-us': BlockContentSchema,
    'es-mx': BlockContentSchema
});
//# sourceMappingURL=blockContent.js.map